module.exports = __webpack_public_path__ + "static/img/pete_pictgrid8_800x639.ba95b22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_pictgrid8_800x639.jpg
// module id = TA0E
// module chunks = 0